<template>
  <div class="mt-3">
    <v-form v-model="validForm" ref="passwordForm">
      <v-row>
        <v-col cols="6">
          <h2>{{ $t('label.changePassword') }}</h2>
          <v-text-field
            v-model="user.oldPassword"
            :label="$t('label.passwordCurrent')"
            type="password"
            :prepend-inner-icon="mdiFormTextboxPassword"
            hide-details
          />
          <v-text-field
            v-model="user.newPassword"
            :label="$t('label.passwordNew')"
            type="password"
            autocomplete="new-password"
            :prepend-inner-icon="mdiFormTextboxPassword"
            hide-details
          />
          <v-text-field
            v-model="user.newPasswordConfirm"
            :label="$t('label.passwordConfirm')"
            type="password"
            autocomplete="new-password"
            :prepend-inner-icon="mdiFormTextboxPassword"
            hide-details
          />
        </v-col>
        <v-col class="mt-5" cols="6">
          <v-select
            v-model="user.language"
            :items="listLanguages"
            item-text="text"
            item-value="value"
            :label="$t('label.language')"
            :prepend-inner-icon="mdiTranslate"
            hide-details
          />
          <v-select
            v-model="user.formatDate"
            :items="listDateFormats"
            item-text="text"
            item-value="value"
            :label="$t('label.formatDate')"
            hide-details
          />
          <v-select
            v-model="user.formatTime"
            :items="listTimeFormats"
            item-text="text"
            item-value="value"
            :label="$t('label.formatTime')"
            hide-details
          />
          <v-select
            v-model="user.firstDay"
            :items="listFirstDayOfWeek"
            item-text="text"
            item-value="value"
            :label="$t('label.firstDayOfWeek')"
            hide-details
          />
        </v-col>
      </v-row>
    </v-form>
    <v-row>
      <v-col>
        <v-btn color="colorSave" @click="changePassword">{{ $t('btn.save') }}</v-btn>
      </v-col>
    </v-row>
    <v-snackbar v-model="saveSnack" :timeout="3500" top color="green">{{ $t('msg.settingsSaved') }}</v-snackbar>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';

import { mdiFormTextboxPassword, mdiTranslate } from '@mdi/js';

export default Vue.extend({
  name: 'SettingsUser',
  data: () => ({
    saveSnack: false,
    listLanguages: [],
    listDateFormats: [
      { text: '21.12.2021', value: 'DD.MM.YYYY' },
      { text: '21/12/2021', value: 'DD/MM/YYYY' },
      { text: '21-12-2021', value: 'DD-MM-YYYY' },
      { text: '2021-12-21', value: 'YYYY-MM-DD' },
      { text: '2021/12/21', value: 'YYYY/MM/DD' },
    ],
    listTimeFormats: [
      { text: '16:23', value: 'HH:mm' },
      { text: '04:23pm', value: 'hh:mmA' },
    ],
    user: {
      oldPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      formatDate: '',
      formatTime: '',
      firstDay: 0,
      language: '',
    },
    validForm: false,
    rules: {
      requiredLength: (value: any) => value.length > 3 || 'Délka hesla je minimálně 4 znamky', // TODO: pridat do prekladu
    },
    mdiFormTextboxPassword: mdiFormTextboxPassword,
    mdiTranslate: mdiTranslate,
  }),
  mounted() {
    this.listLanguagesLoad();
    this.user.language = this.$store.state.auth.language;
    this.user.formatDate = this.$store.state.auth.df.date;
    this.user.formatTime = this.$store.state.auth.df.time;
    this.user.firstDay = this.$store.state.auth.df.firstDayOfWeek;
    const form: any = this.$refs.passwordForm;
    form.validate();
  },
  computed: {
    listFirstDayOfWeek: function () {
      return [
        { text: this.$i18n.t('label.sunday'), value: 0 },
        { text: this.$i18n.t('label.monday'), value: 1 },
      ];
    },
  },
  methods: {
    changePassword() {
      const form: any = this.$refs.passwordForm;
      if (form.validate() !== true) {
        this.$store.commit('globalMessage', this.$i18n.t('msg.errPasswordChange'));
      } else {
        // const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})');
        if (this.user.newPassword === this.user.newPasswordConfirm) {
          /*if (strongRegex.test(this.user.newPassword) === false) {
            this.notifyMessage = 'Password does not meet security policy';
            return;
          }*/
          axios
            .post('/api/v1/user/ownsettings', this.user)
            .then((response) => {
              switch (response.data.message) {
                case 'wrongOldPassword':
                  this.$store.commit('globalMessage', this.$i18n.t('msg.errPasswordChange'));
                  break;
                default:
                  this.user.oldPassword = '';
                  this.user.newPassword = '';
                  this.user.newPasswordConfirm = '';
                  this.saveSnack = true;
              }
              this.$store.dispatch('checkLogin'); // Pre updatenutie dateTime formats
              this.$i18n.locale = this.user.language;
              this.$vuetify.lang.current = this.user.language;
              this.$moment.locale(this.user.language);
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        } else {
          this.$store.commit('globalMessage', this.$i18n.t('msg.errPasswordChange'));
        }
      }
    },
    listLanguagesLoad() {
      axios
        .get('/api/v1/languages')
        .then((response) => {
          this.listLanguages = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
  },
});
</script>
